module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/quantum-phone-video.ec8e9431.mp4";